<template>
  <div class="form_box">
    <van-form @submit="onSubmit" label-width="9em" ref="formService">
      <van-cell-group>
        <van-field
          name="reg_mer_type"
          label="商户类型"
          :value="reg_mer_type"
          :rules="[{ required: true, message: '请选择商户类型' }]"
        >
          <template #input>
            <select-popup
              v-model="reg_mer_type"
              :columns="[
                { text: '企业商户', value: '00' },
                { text: '个体商户', value: '01' },
                { text: '小微商户', value: '02' },
                { text: '机关事业单位或社会团体', value: '03' },
                { text: '民办非企业', value: '05' },
              ]"
            />
          </template>
        </van-field>
        <van-field
          v-show="false"
          name="isChain"
          label="是否连锁商户"
          :value="isChain"
          :rules="[{ required: true, message: '请选择是否连锁商户' }]"
        >
          <template #input>
            <select-popup
              v-model="isChain"
              :columns="[
                { text: '是', value: '0' },
                { text: '否', value: '1' },
              ]"
            />
          </template>
        </van-field>
      </van-cell-group>
      <real-name-form
        :reg_mer_type="reg_mer_type"
        ref="RealNameForm"
        :formObj="formObj"
        :partnerInfo="partnerInfoRealName"
        :changePictureItem="changePictureItem"
      />
      <business-info-form
        :reg_mer_type="reg_mer_type"
        ref="BusinessInfoForm"
        :formObj="formObj"
        :partnerInfo="partnerInfoBusinessInfo"
        :changePictureItem="changePictureItem"
      />
      <account-form
        :reg_mer_type="reg_mer_type"
        ref="AccountForm"
        :formObj="formObj"
      />
      <div>
        <van-button
          class="form_btn"
          round
          block
          type="info"
          native-type="submit"
          :loading="btnLoding"
          >提交</van-button
        >
      </div>
    </van-form>
    <van-popup
      class="agreement_popup"
      v-model="agreementShow"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :safe-area-inset-bottom="true"
    >
      <h3 class="agreement_title">{{ agreementTitle }}</h3>
      <div class="agreement_content" v-html="agreementContent"></div>
      <van-button
        class="agreement_btn"
        round
        type="info"
        @click="agreementShow = false"
        >同意并确认</van-button
      >
    </van-popup>
    <!-- <van-dialog
      v-model="errorShow"
      theme="round-button"
      confirmButtonColor="#4b79f2"
    >
      <van-icon name="warning" class="error_icon" color="#ff3d3d" />
      <p class="error_text">{{ errorText }}</p>
    </van-dialog> -->
  </div>
</template>

<script>
import { Toast } from "vant";
import SelectPopup from "./components/SelectPopup";
import RealNameForm from "./components/RealNameForm";
import BusinessInfoForm from "./components/BusinessInfoForm";
import AccountForm from "./components/AccountForm";
export default {
  name: "FormService",
  components: {
    SelectPopup,
    RealNameForm,
    BusinessInfoForm,
    AccountForm,
  },
  data() {
    return {
      // errorShow: false,
      // errorText: "",
      reg_mer_type: "",
      isChain: "1",
      btnLoding: false,
      agreementShow: true,
      agreementContent: "",
      agreementTitle: "",
      defaultImgList: [],
      formObj: {
        picture: [],
        commitData: {
          complexUploadBasic: {},
        },
      },
      partnerInfoRealName: {
        legal_name: "",
        legal_idcard_no: "",
        legalCardBeginDate: "",
        legal_card_deadline: "",
      },
      partnerInfoBusinessInfo: {
        shop_name: "",
        shop_lic: "",
        shop_country_id: "",
        shop_addr_ext: "",
      },
      changePictureItem: {
        document_name: "",
        document_type: "",
        file_path: "",
        file_size: "",
        url: "",
      },
    };
  },
  created() {
    const SIGN_TYPE = this.$route.query.type;
    this.getFormContent(SIGN_TYPE);
    this.getAgreementContent(
      SIGN_TYPE,
      SIGN_TYPE === 1 ? "tsgSignServeAgreement" : "ZwSignServeAgreement"
    );
    this.getDefaultImg(SIGN_TYPE);
  },
  methods: {
    async getPartnerDetail() {
      const res = await this.$apis.userServe.getPartnerDetail();
      if (res.resultCode === "200") {
        if (res.data.review) {
          console.log(res.data.review);
          this.reg_mer_type = "00";
          this.toUploadImg([
            {
              document_name: "法人身份证",
              document_type: "0001",
              url: res.data.review.lpidCardFront,
            },
            {
              document_name: "身份证反面",
              document_type: "0011",
              url: res.data.review.lpidCardBack,
            },
            {
              document_name: "商户营业执照",
              document_type: "0002",
              url: res.data.review.businessLicense,
            },
          ]);
          this.partnerInfoRealName = {
            legal_name: res.data.review.lpName,
            legal_idcard_no: res.data.review.lpidCardNum,
            legalCardBeginDate: res.data.review.validityPeriodBegin,
            legal_card_deadline: res.data.review.validityPeriod,
          };
          this.partnerInfoBusinessInfo = {
            shop_name: res.data.review.enterpriseName,
            shop_lic: res.data.review.socialUnifiedCode,
            shop_country_id: res.data.review.districtCode,
            shop_addr_ext: res.data.review.detailAddress,
          };
        }
      }
    },
    async getFormContent(selfContractType) {
      const res = await this.$apis.zzsignServe.getFilledContent({
        selfContractType,
      });
      if (res.resultCode === "200" && res.content.commitData) {
        this.reg_mer_type =
          res.content.commitData.complexUploadBasic.reg_mer_type;
        this.isChain = res.content.commitData.complexUploadBasic.isChain;
        this.formObj = res.content;
      } else {
        this.getPartnerDetail();
      }
    },
    async getAgreementContent(serveType, serveName) {
      // serveName 对应两种签约业务用户协议接口名
      // tsgSignServeAgreement --- 投审稿业务用户协议接口名
      // ZwSignServeAgreement --- 电商业务用户协议接口名
      const res = await this.$apis.zzsignServe[serveName]();
      if (res.resultCode === "200") {
        this.agreementContent = res.content.detail[0].content;
        this.agreementTitle =
          serveType === "1"
            ? "商家服务协议（投审稿业务）"
            : "商家服务协议（电商业务）";
      }
    },
    async onSubmit(values) {
      this.btnLoding = true;
      console.log(values, "11");
      let zwSelfContractType = this.$route.query.type;
      // 数据处理
      let formObj = {
        zwBankName: JSON.parse(values.bank_no).text,
        zwSelfContractType,
        complexUploadBasic: {
          pic_list: [],
          bnfList: [
            {
              bnfPicList: [],
            },
          ],
          sign_type: "SHA-256",
        },
      };
      for (const key in values) {
        if (values[key] instanceof Array && !key.includes("bnf")) {
          if (values[key].length > 0) {
            let pic_list = values[key].filter(
              (item) => item.file_path && item.file_path !== ""
            );
            formObj.complexUploadBasic["pic_list"].push(...pic_list);
          } else {
            continue;
          }
        } else if (key === "shop_country_id") {
          formObj.complexUploadBasic.shop_province_id = values[key].slice(0, 2);
          formObj.complexUploadBasic.shop_city_id = values[key].slice(0, 4);
          formObj.complexUploadBasic[key] = values[key];
        } else if (key === "areaText") {
          let areaList = values[key].split("-");
          formObj.shopProvinceName = areaList[0];
          formObj.shopCityName = areaList[1];
          formObj.shopCountryName = areaList[2];
        } else if (key === "mccCode") {
          let jsonObj = JSON.parse(values[key]);
          formObj.complexUploadBasic[key] = jsonObj.value;
          formObj.mccName = jsonObj.text;
        } else if (key === "bank_no") {
          let jsonObj = JSON.parse(values[key]);
          formObj.complexUploadBasic[key] = jsonObj.value;
        } else if (key === "zwShareholderIsJuridicalPerson") {
          if (values[key] === "1") {
            formObj[key] = true;
            formObj.complexUploadBasic.shareholderName = values.legal_name;
            formObj.complexUploadBasic.shareholderCertno =
              values.legal_idcard_no;
            formObj.complexUploadBasic.shareholderCertBeginDate =
              values.legalCardBeginDate;
            formObj.complexUploadBasic.shareholderCertExpire =
              values.legal_card_deadline;
            formObj.complexUploadBasic.shareholderHomeAddr = values.homeAddr;
          } else {
            formObj[key] = false;
          }
        } else if (key.includes("bnf")) {
          if (values[key] instanceof Array) {
            if (values[key].length > 0) {
              let pic_list = values[key].filter(
                (item) => item.file_path && item.file_path !== ""
              );
              formObj.complexUploadBasic.bnfList[0].bnfPicList.push(...pic_list);
            }
          } else {
            formObj.complexUploadBasic.bnfList[0][key] = values[key];
          }
        } else if (key === "homeAddr") {
          formObj.complexUploadBasic.legalmanHomeAddr = values.homeAddr;
        } else if (
          key === "zwBusinessLicenseType" ||
          key === "bank_location" ||
          key === "bank_mobile"
        ) {
          formObj[key] = values[key];
        } else {
          formObj.complexUploadBasic[key] = values[key];
        }
      }
      formObj.complexUploadBasic.pic_list.push(...this.defaultImgList);
      delete formObj.complexUploadBasic.undefined;
      console.log(formObj, "formObj");

      // 表单提交接口
      const res = await this.$apis.zzsignServe.complexUploadBasic(formObj);
      console.log(res, "res");
      if (res.resultCode === "200") {
        if (res.data.res_code === "0000") {
          //     let content = {
          //       selfContractBaseInfo: {
          //         bankAcctName: values.bank_acct_name,
          //         bankAcctNo: values.bank_acct_no,
          //         bankName: JSON.parse(values.bank_no).text,
          //         umsRegId: res.data.ums_reg_id,
          //       },
          //     };
          //     dispatch(setContent(content))

          if (values.bank_acct_type === "1") {
            let data = {
              ums_reg_id: res.data.ums_reg_id,
              company_account: values.bank_acct_no,
              zwSelfContractType,
            };
            // 银行打款测试接口
            const response = await this.$apis.zzsignServe.requestAccountVerify(
              data
            );
            if (
              response.resultCode === "200" &&
              response.data.res_code === "0000"
            ) {
              this.$router.replace(
                `/service-sign/public-verification?type=${zwSelfContractType}&umsRegId=${res.data.ums_reg_id}`
              );
            } else {
              Toast("系统错误，请稍后重试。");
            }
          } else {
            this.$router.replace(
              `/service-sign/agreement-sign?type=${zwSelfContractType}&umsRegId=${res.data.ums_reg_id}`
            );
            // let data = {
            //   ums_reg_id: res.data.ums_reg_id,
            //   zwSelfContractType,
            // };
            // 获取签约页面接口
            // const response = await this.$apis.zzsignServe.agreementSign(data);
            // if (response.resultCode === "200") {
            //   if (Object.keys(response.content)) {
            //     window.open(response.content.url, "_blank");
            //   } else {
            //     Toast("系统错误，请稍后重试。");
            //   }
            // } else {
            //   Toast("系统错误，请稍后重试。");
            // }
          }
        } else {
          Toast(res.data.res_msg);
        }
      } else {
        Toast("系统错误，请稍后重试。");
      }
      this.btnLoding = false;
    },
    // 默认图片接口
    async getDefaultImg(zwSelfContractType) {
      this.btnLoding = true;
      const res = await this.$apis.zzsignServe.uploadDefaultImg({
        zwSelfContractType,
      });
      if (res.resultCode === "200") {
        this.defaultImgList = res.data;
        this.btnLoding = false;
      } else {
        this.getDefaultImg(zwSelfContractType);
      }
    },
    toUploadImg(imgArr) {
      imgArr.forEach((item) => {
        if (item.url) {
          this.changePictureItem = {
            ...item,
            file_path: "",
            file_size: "",
          };
          this.$apis.zzsignServe
            .imgToFileObj(
              this.$global.imgUrl + item.url,
              item.document_name + ".png"
            )
            .then((imgObj) => {
              this.afterRead(imgObj, item);
            });
        }
      });
    },
    // 图片上传
    async afterRead(file, listItem) {
      let submitType = this.$route.query.type;
      let formDataParams = new FormData();
      formDataParams.append("file", file);
      formDataParams.append("type", listItem.document_type);
      formDataParams.append("zwSelfContractType", submitType);
      const payRes = await this.$apis.zzsignServe.serveSignUplod(
        formDataParams,
        listItem.document_type
      );
      if (payRes.resultCode === "200" && payRes.data.res_code === "0000") {
        this.changePictureItem = {
          ...listItem,
          file_path: payRes.data.file_path,
          file_size: payRes.data.file_size,
          url: payRes.content.path,
        };
      } else {
        Toast("图片上传失败!");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form_box {
  padding: 12px;
  min-height: 100vh;
  background: #f5f5f5;

  &::v-deep .van-cell-group {
    border-radius: 8px;
    overflow: hidden;
    padding: 0 12px;

    .van-cell {
      padding: 17px 0;
      border-bottom: 1px solid #eee;
      align-items: center;

      &:last-child {
        border: none;
      }

      .van-cell__title {
        color: #333333;
      }

      .van-field__control {
        text-align: right;
      }

      &::after {
        border: none;
      }
    }

    .van-field--error {
      position: relative;
      padding-bottom: 41px;

      .van-cell__title,
      .van-cell__value {
        position: unset;
      }

      .van-field__error-message {
        position: absolute;
        left: 0;
        // text-align: right;
      }

      .van-field__control {
        color: #333;

        &::placeholder {
          color: #333;
        }
      }
    }
  }

  .agreement_popup {
    padding: 25px 15px 6px;

    .agreement_title {
      font-size: 17px;
      color: #333333;
      line-height: 18px;
      text-align: center;
    }

    .agreement_content {
      overflow-y: auto;
      margin: 20px 0 13px;
      padding: 0 10px;
      max-height: 390px;
      font-size: 16px !important;
      color: #333 !important;
      font-family: PingFang SC, Microsoft YaHei !important;
      font-weight: normal !important;
      &::v-deep * {
        font-size: 16px !important;
        color: #333 !important;
        font-family: PingFang SC, Microsoft YaHei !important;
        font-weight: normal !important;
      }
      // &::v-deep span {
      //   font-size: 30px !important;
      //   color: #333 !important;
      //   font-family: PingFang SC, Microsoft YaHei !important;
      //   font-weight: normal !important;
      // }
    }

    .agreement_btn {
      width: 100%;
      height: 44px;
      background: #4a79f1;
    }
  }
}

.error_icon {
  margin-top: 25px;
  width: 100%;
  text-align: center;
  font-size: 35px;
}

.error_text {
  margin-top: 17px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #333333;
  line-height: 21px;
  text-align: center;
}

.form_btn {
  margin: 24px auto 0;
  width: 345px;
  height: 44px;
  background: #4a79f1;
  border-radius: 22px;
}
</style>
